export default {
  baseStyle: {
    color: 'default.200',
  },
  sizes: {
    sm: 'small',
    lg: 'large',
  },
  defaultProps: {
    size: 'large',
  },
};
